import NearbyDevices from "src/modules/pairing-requester/scenes/NearbyDevices";
import Waiting from "src/modules/pairing-requester/scenes/Waiting";
import Synchronizing from "src/modules/pairing-requester/scenes/Synchronizing";
import DevicesOnly from "src/modules/pairing-requester/scenes/DevicesOnly";
import RequesterSuccess from "src/modules/pairing-requester/scenes/Success";
import AccountRequest from "src/modules/pairing-requester/scenes/AccountRequest";
import ResponderSuccess from "src/modules/pairing-responder/scenes/Success";
import ManualPairing from "src/modules/pairing-manually/scenes/ManualPairing";
import DisplayCode from "src/modules/pairing-manually/scenes/DisplayCode";
import EnterCode from "src/modules/pairing-manually/scenes/EnterCode";
import ScanQrCode from "src/modules/pairing-manually/scenes/ScanQrCode";

import Promotion from "src/modules/pairing-requester/scenes/Promotion";
import Redeeming from "src/modules/pairing-requester/scenes/Redeeming";
import RedeemSuccess from "src/modules/pairing-requester/scenes/RedeemSuccess";
import SetUpAccount from "src/modules/pairing-requester/scenes/SetUpAccount";
import WhatIsFamilyAccount from "src/modules/pairing-requester/scenes/WhatIsFamilyAccount";

import SignUp from "src/modules/auth/scenes/SignUp";
import Login from "src/modules/auth/scenes/Login";

export default [
  { id: "nearby-devices", Component: NearbyDevices },
  { id: "waiting", Component: Waiting },
  { id: "account-request", Component: AccountRequest },
  {
    id: "initial-sign-up",
    Component: function InitialSignUp({ flow, mode }) {
      return (
        <SignUp
          onSuccess={() => {
            const isPromotion = flow.history.find(
              (path) => path === "promotion"
            );
            if (isPromotion) flow.push("redeeming");
            else flow.push("requester-success", { state: { didSignUp: true } });
          }}
          mode={mode}
          onBack={() => flow.previous()}
          openLogin={() => flow.push("initial-login")}
        />
      );
    }
  },
  {
    id: "initial-login",
    Component: function InitialLogin({ flow, mode }) {
      return (
        <Login
          onSuccess={() => {
            const isPromotion = flow.history.find(
              (path) => path === "promotion"
            );
            if (isPromotion) flow.push("redeeming");
            else flow.push("requester-success", { state: { didLogIn: true } });
          }}
          mode={mode}
          onBack={() => flow.previous()}
        />
      );
    }
  },
  { id: "promotion", Component: Promotion },
  { id: "redeeming", Component: Redeeming },
  { id: "redeem-success", Component: RedeemSuccess },
  { id: "set-up-account", Component: SetUpAccount },
  { id: "what-is-family-account", Component: WhatIsFamilyAccount },
  { id: "synchronizing", Component: Synchronizing },
  { id: "devices-only", Component: DevicesOnly },
  { id: "requester-success", Component: RequesterSuccess },
  { id: "responder-success", Component: ResponderSuccess },
  { id: "manual-pairing", Component: ManualPairing },
  { id: "display-code", Component: DisplayCode },
  { id: "scan-qr-code", Component: ScanQrCode },
  { id: "enter-code", Component: EnterCode }
];
